import { actionCreatorFactory } from 'typescript-fsa';
import { IDetailsPayload, IDetailsSidebarClosePayload } from './detailsSidebar.interface';

export namespace DetailsSidebarAction {
  const actionCreator = actionCreatorFactory('DetailsSidebar');

  export const open = actionCreator<IDetailsPayload>('OPEN');
  export const close = actionCreator<IDetailsSidebarClosePayload | void>('CLOSE');
  export const toggleEdit = actionCreator('TOGGLE_EDIT');
  export const openDefault = actionCreator<{ id: IDetailsPayload['id'] }>('OPEN_DEFAULT');
  export const setState = actionCreator<IDetailsPayload>('SET_STATE');

  export const destroy = actionCreator('DESTROY');
}
